import React from 'react';
import {
  Outlet,
  RouteObject
} from 'react-router-dom';

import { OrganizationLayout } from './OrganizationLayout';
import { ProjectDashboardActivity } from './DashboardActivity/DashboardActivity';
import { TasksActivity } from './TasksActivity/TasksActivity';
import { DailyReportsActivity } from './DailyReportsActivity/DailyReportsActivity';
import { InstallationsActivity } from './InstallationsActivity/InstallationsActivity';
import { ProjectsActivity } from './ProjectsActivity/ProjectsActivity';
import { PlansActivity } from './PlansActivity/PlansActivity';
import { FilesActivity } from './FilesActivity/FilesActivity';
import { ClientReportsActivity } from './ClientReportsActivity/ClientReportsActivity';
import { TeamActivity } from './TeamActivity/TeamActivity';
import { DailyReportActivity } from './DailyReportActivity/DailyReportActivity';
import { ProjectMilestonesActivity } from './ProjectMilestonesActivity/ProjectMilestonesActivity';
import { ProjectMilestoneActivity } from './ProjectMilestoneActivity/ProjectMilestoneActivity';
import { InstallationActivity } from './InstallationActivity/InstallationActivity';
import { PlanActivity } from './PlanActivity/PlanActivity';
import { FolderActivity } from './FolderActivity/FolderActivity';
import { FileActivity } from './FileActivity/FileActivity';
import { ProfileActivity } from './ProfileActivity/ProfileActivity';
import { PersonActivity } from './PersonActivity/PersonActivity';
import { ClientReportActivity } from './ClientReportActivity/ClientReportActivity';
import { PlanSetsActivity } from './PlanSetsActivity/PlanSetsActivity';
import { PlanSetActivity } from './PlanSetActivity/PlanSetActivity';
import { MilestonesActivity } from './MilestonesActivity/MilestonesActivity';


export const root: RouteObject = {
  path: 'organization',
  element: (<OrganizationLayout />),
  children: [
    {
      path: 'projects',
      element: <ProjectsActivity />
    },
    {
      path: 'projects/:projectId',
      element: <Outlet />,
      children: [
        {
          path: 'dashboard',
          element: <ProjectDashboardActivity />,
          children: [
            {
              // gnat chart
              path: 'milestones',
              element: <ProjectMilestonesActivity />,
              children: [
                {
                  path: ':milestoneId',
                  element: <ProjectMilestoneActivity />,
                  children: []
                }
              ]
            }
          ]
        },
        {
          path: 'milestones',
          element: <MilestonesActivity />,
          children: [
            {
              path: ':milestoneId',
              element: <ProjectMilestoneActivity />,
              children: []
            }
          ]
        },
        {
          path: 'tasks',
          element: <TasksActivity />
        },
        {
          path: 'dailyreports',
          element: <DailyReportsActivity />,
          children: [
            {
              path: ':dailyReportId',
              element: <DailyReportActivity />
            }
          ]
        },

        {
          path: 'installations',
          element: <InstallationsActivity />,
          children: [
            {
              path: ':installationId',
              element: <InstallationActivity />
            }
          ]
        },
        {
          path: 'planSets',
          element: <PlanSetsActivity />,
          children: [
            {
              path: ':planSetId',
              element: <PlanSetActivity />
            }
          ]
        },
        {
          path: 'plans',
          element: <PlansActivity />,
          children: [
            {
              path: ':planId',
              element: <PlanActivity />,
              children: [
                {
                  path: 'detail/:planApiFileId',
                  element: <PlanActivity />
                }
              ]


            }
          ]
        },
        {
          path: 'folders',
          element: <Outlet />,
          children: [
            {
              path: ':folderId',
              element: <FolderActivity />
            }
          ]
        },
        {
          path: 'files',
          element: <FilesActivity />,
          children: [
            {
              path: ':documentId',
              element: <FileActivity />
            }
          ]
        },
        {
          path: 'clientreports',
          element: <ClientReportsActivity />,
          children: [
            {
              path: ':clientReportId',
              element: <ClientReportActivity />
            }
          ]
        },
        {
          path: 'team',
          element: <TeamActivity />,
          children: [
            {
              path: ':personId',
              element: <PersonActivity />
            }
          ]
        },
        {
          path: 'profile',
          element: <ProfileActivity />
        }
      ]
    }
  ]
};

export type IOrganizationRoutesTypes = typeof root;
